import { render, staticRenderFns } from "./RelatoriosPersonalizados.vue?vue&type=template&id=2e277336&scoped=true"
import script from "./RelatoriosPersonalizados.vue?vue&type=script&lang=js"
export * from "./RelatoriosPersonalizados.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosPersonalizados.vue?vue&type=style&index=0&id=2e277336&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e277336",
  null
  
)

export default component.exports